import { PLATFORM_TRADEMARK, PLATFORM_TRADEMARK_NOTICE } from '../../../config/branding';
import './PublicBrandSignature.css';

// Assinatura de marca do rodapé das telas públicas (agendamento, pedido, portal do colaborador,
// página da empresa). Identifica a plataforma para quem acessa sem login, onde não há menu nem
// cabeçalho administrativo que revele de quem é o sistema.
//
// Usa PLATFORM_TRADEMARK e não PROJECT_NAME de propósito: PROJECT_NAME muda por ambiente
// (white label) e a titularidade da marca, não.
const PublicBrandSignature = ({ className = '' }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={`public-brand-signature ${className}`.trim()}>
            <span className="public-brand-signature__mark">{PLATFORM_TRADEMARK}</span>
            <span className="public-brand-signature__notice">
                {`© ${currentYear} ${PLATFORM_TRADEMARK_NOTICE}`}
            </span>
        </footer>
    );
};

export default PublicBrandSignature;
